import { render } from "./ListArticleView.vue?vue&type=template&id=45dde444"
import script from "./ListArticleView.vue?vue&type=script&lang=js"
export * from "./ListArticleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__